import _Table from "hzero-ui/lib/table";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["loading"];
import React, { forwardRef, useContext } from "react";
import { ThemeContext, isEmpty } from "@hzero-front-ui/core/lib/utils";
import { useLoadingEl } from "../Spin";
import "./css";
var WrappedTable = forwardRef(function (props, ref) {
  var loading = props.loading,
    rest = _objectWithoutProperties(props, _excluded);
  var indicator = useLoadingEl();
  var _useContext = useContext(ThemeContext),
    schema = _useContext.schema,
    resolvedTheme = _useContext.resolvedTheme;
  var finalLoading = typeof loading === "object" && loading !== null ? _objectSpread(_objectSpread({}, loading), {}, {
    indicator: indicator
  }) : {
    indicator: indicator,
    spinning: loading || false
  };
  if (isEmpty(schema, resolvedTheme)) {
    finalLoading = loading;
  }
  return /*#__PURE__*/React.createElement(_Table, Object.assign({
    ref: ref
  }, rest, {
    loading: finalLoading
  }));
});
export default Object.assign(WrappedTable, _Table);